import { Breadcrumbs, Stack } from '@mui/material';

interface Props {
	breadcrumbs: JSX.Element[];
}

export const BreadCrumb = ({ breadcrumbs }: Props) => {
	return (
		<Stack spacing={2}>
			<Breadcrumbs separator='›' aria-label='breadcrumb'>
				{breadcrumbs}
			</Breadcrumbs>
		</Stack>
	);
};
